
export function getDisplayNameFromPeriodType(periodeType: string): string {
    switch (periodeType) {
    case PeriodTab.HALFYEAR:
        return 'Halvår';
    case PeriodTab.MONTH:
        return 'Måned';
    case PeriodTab.ROLLINGMONTHS:
        return 'Rullende måneder';
    case PeriodTab.MONTHYTD:
        return 'År-til-dato';
    case PeriodTab.QUARTER:
        return 'Kvartal';
    case PeriodTab.ROLLYINGYEAR:
        return 'Rullende år';
    case PeriodTab.QUARTERYTD:
        return 'År-til-dato';
    case PeriodTab.LASTTHREEMONTHS:
        return 'Seneste 3 måneder';
    case PeriodTab.WEEK:
        return 'Uge';
    case PeriodTab.YEAR:
        return 'År';
    case PeriodTab.YEARMONTH:
        return 'År/måned';
    case PeriodTab.YEARQUARTER:
        return 'År/kvartal';
    case PeriodTab.YEARWEEK:
        return 'År/uge';
    default:
        return periodeType;
    }

}

export enum PeriodTab {
    HALFYEAR = 'HY',
    MONTH = 'M',
    ROLLINGMONTHS = 'MMAT',
    MONTHYTD = 'MYTD',
    QUARTER = 'Q',
    ROLLYINGYEAR = 'QMAT',
    QUARTERYTD = 'QYTD',
    LASTTHREEMONTHS = 'STM',
    WEEK = 'W',
    YEAR = 'Y',
    YEARMONTH = 'Y_M',
    YEARQUARTER = 'Y_Q',
    YEARWEEK = 'Y_W',
}
